
import React from 'react';

import { TabPanel } from '../../core';
import MeasurementPanel from './MeasurementPanel';

const renderTabPanel = (props) => {
    return (
        <TabPanel key={props.name} name={props.name} iconName={props.iconName} title={props.title}>
            <MeasurementPanel />
        </TabPanel>
    );
}

export default renderTabPanel;
